import { render } from "./certificateDrawer.vue?vue&type=template&id=6340de6a&ts=true"
import script from "./certificateDrawer.vue?vue&type=script&lang=ts"
export * from "./certificateDrawer.vue?vue&type=script&lang=ts"

import "./certificateDrawer.vue?vue&type=style&index=0&id=6340de6a&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__